import { TabPanel } from 'primereact/tabview'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import {
  Btn,
  CustomCheckbox,
  CustomDropdown,
  CustomInputTextArea,
  CustomModal,
  CustomTabView,
  InputCep,
  InputPhone,
  InputText,
} from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useModalCliente, { LOAD_MESSAGE } from './ModalClienteHook'
import ModalMapCliente from './ModalMapCliente'
import { Button } from 'primereact/button'
import InputCoordenada from '../../../../../components/InputCoordenada/InputCoordenada'
import InputCnpjCpf from '../../../../../components/InputCnpjCpf/InputCnpjCpf'

function ModalCliente({
  show,
  selectedCliente,
  onModalClose,
  onModalSave,
  dispatch,
  selectedTp,
  selectedCiclo,
  readOnly = false,
  associateWithSelectedCycle = false,
}) {
  const { state, localDispatch } = useModalCliente()

  useEffect(() => {
    if (show) {
      localDispatch.onInit(selectedCliente, selectedCiclo)
    }
  }, [show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.LOADING:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.buildInfo(state.selectedCustomer, state)
        break
      case LOAD_MESSAGE.SAVE_FROM_MAP:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.selectSaveType(
          state.selectedCustomer,
          selectedCiclo,
          state.cliente,
          associateWithSelectedCycle,
        )
        break
      case LOAD_MESSAGE.SAVE_NEW:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.saveNewCustomer(state.cliente, selectedTp)
        break
      case LOAD_MESSAGE.SAVE_UPDATE:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.saveUpdateCustomer(state.cliente)
        break
      case LOAD_MESSAGE.SAVE_NEW_ASSOC:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.saveNewAndAssocCompany(state.cliente, selectedTp, selectedCiclo)
        break
      case LOAD_MESSAGE.LOADING_NEW:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.fetchUFs()
        break
      case LOAD_MESSAGE.LOADING_EDIT:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.fetchUFs(state.cliente.uf_id)
        break
      case LOAD_MESSAGE.LOADING_CITIES:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.fetchCities(state.selectedUf.id, state.selectedCustomer)
        break
      case LOAD_MESSAGE.LOADING_CNPJ_DATA:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.fetchCnpjData(state.cliente.cnpj)
        break
      case LOAD_MESSAGE.LOADING_CITY_COORDINATES:
        localDispatch.fetchCities(state.selectedUf.id, {
          city_id: state.cliente.city_id,
        })

        localDispatch.fetchCoordinates(
          state.cliente.number,
          state.cliente.address,
          state.cliente.district,
          state.selectedCity,
        )
        break
      case LOAD_MESSAGE.LOADING_COORDINATES:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        const cidadeSelecionada = state.cities.find(c => c.id === state.cliente.city_id)
        if (!cidadeSelecionada) {
          dispatch(showMessageBox(null, 'Uma cidade precisa ser selecionada'))
          localDispatch.resetError()
          dispatch(hideLoadingBox())
          break
        }
        localDispatch.fetchCoordinates(
          state.cliente.number,
          state.cliente.address,
          state.cliente.district,
          cidadeSelecionada,
        )
        break
      case LOAD_MESSAGE.SUCCESS:
        dispatch(showMessageBox(state.loadingMessage, null))
        dispatch(hideLoadingBox())
        onModalSave(state.cliente)
        localDispatch.resetState()
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetError()
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      header="Cliente"
      isVisible={show}
      width={850}
      onClose={() => {
        onModalClose()
        localDispatch.clearModalOnClose()
      }}
    >
      <CustomTabView activeIndex={state.activeTab} onTabChange={localDispatch.onTabChange}>
        <TabPanel header={'Dados'}>
          <form className="p-grid" style={{ width: 800 }}>
            <div className="p-col-4">
              <InputCnpjCpf
                label="CNPJ/CPF :*"
                marginTop={10}
                value={state.cliente.cnpj}
                onChange={({ value }) => localDispatch.onCnpjChange(value, state.selectedCustomer)}
                disabled={readOnly}
              />
            </div>
            <div className="p-col-4">
              <InputPhone
                label="Telefone :"
                marginTop={10}
                value={state.cliente.phone}
                onChange={value => localDispatch.onInputChange('phone', value)}
                disabled={readOnly}
              />
            </div>
            <div className="p-col-4">
              <CustomDropdown
                optionLabel="name"
                options={state.ufs}
                value={state.selectedUf}
                label="Estado :*"
                filter={true}
                onChange={value => localDispatch.onEstadoChange(value)}
                disabled={readOnly}
              />
            </div>
            <div className="p-col-4">
              <CustomDropdown
                disabled={state.selectedUf === 0 || readOnly}
                optionLabel="name"
                options={state.cities}
                value={state.selectedCity}
                label="Cidade :*"
                filter={true}
                onChange={value => localDispatch.onCityChange('city_id', value)}
              />
            </div>
            <div className="p-col-6">
              <InputText
                label="Razão Social :*"
                marginTop={10}
                value={state.cliente.razaoSocial}
                onChange={value => localDispatch.onInputChange('razaoSocial', value.toUpperCase())}
                disabled={readOnly}
              />
            </div>
            <div className="p-col-6">
              <InputText
                label="Nome Fantasia :*"
                marginTop={10}
                value={state.cliente.nomeFantasia}
                onChange={value => localDispatch.onInputChange('nomeFantasia', value.toUpperCase())}
                disabled={readOnly}
              />
            </div>

            <div className="p-col-6">
              <InputText
                label="Endereço :*"
                marginTop={10}
                value={state.cliente.address}
                onChange={value => localDispatch.onInputChange('address', value.toUpperCase())}
                disabled={readOnly}
              />
            </div>
            <div className="p-col-4">
              <InputText
                label="Bairro :*"
                marginTop={10}
                value={state.cliente.district}
                onChange={value => localDispatch.onInputChange('district', value.toUpperCase())}
                disabled={readOnly}
              />
            </div>
            <div className="p-col-4">
              <InputText
                label="Número :*"
                marginTop={20}
                value={state.cliente.number}
                onChange={value => localDispatch.onInputChange('number', value)}
                disabled={readOnly}
              />
            </div>

            <div className="p-md-4 p-col-12">
              <InputCep
                label="CEP :"
                marginTop={20}
                value={state.cliente.cep}
                onChange={value => localDispatch.onInputChange('cep', value.value)}
                disabled={readOnly}
              />
            </div>
            <div className=" p-col-4">
              <InputText
                label="Inscrição Estadual :"
                marginTop={20}
                value={state.cliente.inscricao_estadual}
                onChange={value => localDispatch.onInputChange('inscricao_estadual', value)}
                disabled={readOnly}
              />
            </div>
            <div className="p-inputgroup p-col-8" style={{ alignItems: 'flex-end' }}>
              <InputCoordenada
                label={'Coordenadas :*'}
                onChange={value => localDispatch.onInputChange('latitude', value)}
                value={state.cliente.latitude !== 0 ? state.cliente.latitude : null}
                disabled={readOnly}
              />
              <InputCoordenada
                onChange={value => localDispatch.onInputChange('longitude', value)}
                value={state.cliente.longitude !== 0 ? state.cliente.longitude : null}
                disabled={readOnly}
              />
              {!readOnly && (
                <Button
                  icon="pi pi-map-marker"
                  label={'Encontrar'}
                  style={{ backgroundColor: '#14B0BF', height: 30 }}
                  onClick={e => localDispatch.onSearchCoordinatesClick(e, state.cliente.city_id)}
                />
              )}
            </div>
            <div className="p-col-4" style={{ paddingTop: 42 }}>
              <CustomCheckbox
                onChange={value => localDispatch.onInputChange('makeParcialReturn', value)}
                checked={state.cliente.makeParcialReturn}
                disabled={readOnly}
              >
                Faz Devolução Parcial
              </CustomCheckbox>
            </div>
            <div className="p-col-4" style={{ paddingTop: 42 }}>
              <CustomCheckbox
                onChange={value => localDispatch.onInputChange('actived', value)}
                checked={state.cliente.actived}
                disabled={readOnly}
              >
                Ativo
              </CustomCheckbox>
            </div>
            {!readOnly && (
              <div className="p-col-12">
                <Btn
                  onClick={() =>
                    localDispatch.onBtnSalvarClicked(
                      state.selectedCustomer,
                      selectedCiclo,
                      state.cliente,
                      associateWithSelectedCycle,
                    )
                  }
                >
                  Salvar
                </Btn>
              </div>
            )}
          </form>
        </TabPanel>
        <TabPanel header={'Mapa'}>
          <ModalMapCliente
            coordinates={{ longitude: state.cliente.longitude, latitude: state.cliente.latitude }}
            setCoordinates={localDispatch.onCoordinatesChange}
            onSave={localDispatch.saveClientWithFineTuning}
            readOnly={readOnly}
          />
        </TabPanel>
        <TabPanel header={'Observações'}>
          <form className="p-grid" style={{ width: 800 }}>
            <div className="p-col-12">
              <CustomInputTextArea
                label={'Observações'}
                marginTop={10}
                value={state.cliente.observation || ''}
                onChange={value => localDispatch.onInputChange('observation', value.toUpperCase())}
                rows={4}
                disabled={readOnly}
              />
            </div>
            {!readOnly && (
              <div className="p-col-12">
                <Btn
                  onClick={() =>
                    localDispatch.onBtnSalvarClicked(
                      state.selectedCustomer,
                      selectedCiclo,
                      state.cliente,
                      associateWithSelectedCycle,
                    )
                  }
                >
                  Salvar
                </Btn>
              </div>
            )}
          </form>
        </TabPanel>
      </CustomTabView>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp }, ciclo_entrega: { selectedCiclo } }) => ({
  selectedTp,
  selectedCiclo,
})
export default connect(mapStateToProps)(ModalCliente)
